require('./pay-modal/pay-modal.jade')
require('./cancel-modal/app-cancel-modal.jade')
require('./cancel-modal/tv-cancel-modal.jade')
require('./cancel-modal/web-cancel-modal.jade')

PaymentService = ($rootScope, $modal, $cookies) ->
  paidFrom = undefined

  $rootScope.$on 'accountLoaded.gnp.AccountService', (event, userInfo) ->
    paidFrom = userInfo.payment_company

  payModal: ->
    $modal.open
      size: 'lg'
      templateUrl: 'payment/pay-modal/pay-modal.jade'
      controller: 'PayModalCtrl'

  paid: ->
    paidValue = $cookies.get 'paid'
    paidValue == 'true'

  openCancelModal: ->
    switch paidFrom
      when 'SBPS', 'PayPal'
        templatePrefix = 'web'
      when 'Apple', 'Google'
        templatePrefix = 'app'
      else
        templatePrefix = 'tv'
    $modal.open
      size: 'lg'
      templateUrl: "payment/cancel-modal/#{templatePrefix}-cancel-modal.jade"
      controller: 'CancelModalCtrl'

PaymentService.$inject = [
  "$rootScope"
  "$modal"
  "$cookies"
]

module.exports = PaymentService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/payment-service.coffee